export class OhsRecordFieldType {
  key: string;
  name: string;
  hide?: boolean;
  constructor(key: string, name: string) {
    this.key = key;
    this.name = name;
  }
}
